import ItemsProcessedByMonthModule from "./RecurringRevenueByMonthModule";
import ItemsProcessedByMonthSaga from "./redux/RecurringRevenueByMonthSagas";
import ItemsProcessedByMonthReducer from "./redux/RecurringRevenueByMonthReducer";

export default {
  Component: ItemsProcessedByMonthModule,
  moduleName: "itemsProcessedByMonth",
  saga: ItemsProcessedByMonthSaga(),
  reducer: ItemsProcessedByMonthReducer
};
